import { CloseCircleFilled } from '@ant-design/icons';
import { Result, ResultProps, Typography } from 'antd';
import styled from 'styled-components';

const StyledResultTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  margin: 0;
`;

export interface IErrorResultA11yProps extends ResultProps {}

/**
 * Versione del componente Result di Ant Design con supporto per l'accessibilità.
 */
export function ErrorResultA11y(props: IErrorResultA11yProps) {
  const { subTitle, extra, title, ...resultProps } = props;

  return (
    <Result
      status="error"
      icon={<CloseCircleFilled aria-hidden="true" />}
      title={<StyledResultTitle>{title}</StyledResultTitle>}
      subTitle={<Typography.Text>{subTitle}</Typography.Text>}
      extra={extra && <Typography.Text>{extra}</Typography.Text>}
      {...resultProps}
    />
  );
}
